var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('marquee',{attrs:{"scrollamount":_vm.scrollSpeed}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }